import { createStore } from "vuex";
import { auth } from "./auth.module.js";
import { profile } from "./profile.module.js";
import { users } from './user.module';
import { projects } from "./projects.module.js";
import { models } from "./models.module.js";
import { budgets } from "./budget.module.js";
import { evidences } from "./evidences.module.js";
import { analitycs } from "./analitycs.module.js";
import { inventory } from "./inventory.modules.js";
import { purchases } from "./purchases.modules.js";
import { purchasesDetails } from "./purchasesDetails.modules.js";
import { modelsDetails } from "./modelsDetails.modules.js";
import { sizes } from "./sizes.modules.js";
import { production } from "./production.modules.js";
import { productionUsers } from "./productionUsers.modules.js";
import { productionDetails } from "./productionDetails.modules.js";
import { minesExtractions } from "./minesExtractions.module.js";
import { minesExtractionsTransport } from "./minesExtractionsTransport.module.js";
import { minesExtractionsFinal } from "./minesExtractionsFinal.module.js";
import { media } from "./media.modules.js";
import { bodegas } from "./bodegas.modules.js";
import { categories } from "./categories.module.js";
import { crews } from "./crews.modules.js"; // Importa el módulo de crews
import { colors } from "./colors.module.js";
import { mines } from "./mines.modules.js";
import { oficios } from "./oficios.module.js";
import { tallas } from "./tallas.modules.js";
import { productionModels } from "./productionModels.modules.js";
import { modelsModel } from "./modelsModel.modules.js";
import { settings } from "./settings.module.js";
import { payments } from "./payments.modules.js";
import { productionPayments } from "./productionPayments.modules.js";
import { remissions } from "./remissions.module.js";
import { remissionsVehicles } from "./remissionsVehicles.module.js";
import { remissionsDetails } from "./remissionsDetails.module.js";
import { inventoryNews } from "./inventoryNews.modules.js";
import { productionNovelty } from "./productionNovelty.modules.js";
import { productionExtrusion } from "./productionExtrusion.modules.js";
import { productionDrying } from "./productionDrying.modules.js";
import { productionLoading } from "./productionLoading.modules.js";
import { productionUnloading } from "./productionUnloading.modules.js";
import { productionOven } from "./productionOven.modules.js";
import { productionOvenFurnace } from "./productionOvenFurnace.modules.js";
import { productionTransfers } from "./productionTransfers.modules.js";

export default createStore({
  modules: {
    auth,
    profile,
    users, 
    projects, 
    budgets,
    evidences,
    analitycs,
    models,
    inventory,
    purchases,
    purchasesDetails,
    modelsDetails,
    sizes,
    production,
    productionUsers,
    productionModels,
    productionDetails,
    minesExtractions,
    minesExtractionsTransport,
    minesExtractionsFinal,
    media,
    bodegas,
    categories,
    crews, 
    colors,
    mines,
    oficios,
    tallas,
    modelsModel,
    settings,
    payments,
    productionPayments,
    remissions,
    remissionsVehicles,
    remissionsDetails,
    inventoryNews,
    productionNovelty,
    productionExtrusion,
    productionDrying,
    productionLoading,
    productionUnloading,
    productionOven,
    productionOvenFurnace,
    productionTransfers
  },
  state: {
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    sidebarType: "bg-white",
    isRTL: false,
    mcolor: "",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    layout: "default"
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");

      if (sidenav_show.classList.contains("g-sidenav-hidden")) {
        sidenav_show.classList.remove("g-sidenav-hidden");
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    sidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    }
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    }
  },
  getters: {}
});
